const loginAndSignUp = {
  loginTips: "Haben Sie bereits ein HitPaw-Konto? <1>Anmeldung</1>",
  loginSuccessTips: "Login erfolgreich",
  loginErrorTips: "Login fehlgeschlagen",
  loginAccountOrPasswordErrorTips: "Ihre E-Mail oder Ihr Passwort war falsch. Bitte versuchen Sie es erneut.",
  loginAccountNotExitErrorTips: "Die Mailbox ist nicht registriert",
  signUpTips: "Noch kein registrierter Benutzer? ",
  rememberMe: "Konto merken",
  forgotPassword: "Passwort vergessen?",
  forgotPasswordTitle: "Passwort vergessen",
  verifyEmailBtn: "E-Mail bestätigen",
  resetPasswordTitle: "Passwort zurücksetzen",
  resetPasswordLabel: "Bitte setzen Sie Ihr Passwort zurück",
  resetPasswordPlaceholder: "Geben Sie ein neues Passwort ein",
  resetPasswordSuccessTips: "Passwort erfolgreich geändert",
  signUpPrivacyTips: "Mit der Anmeldung erklären Sie sich mit unseren <1>Nutzungsbedingungen</1> und <3>Datenschutzrichtlinien</3> einverstanden.",
  loginPrivacyTips: "Wenn Sie fortfahren, erklären Sie sich mit unseren <1>Nutzungsbedingungen</1> und <3>Datenschutzerklärung</3> einverstanden",
  signUpSuccessTips: "Ihr Konto wurde erfolgreich registriert！",
  getCode: "Code erhalten",
  getCodeSuccessTips: "Es wurde an Ihre Mailbox gesendet, bitte überprüfen Sie es",
  verificationSuccessTips: "Mailbox-Überprüfung erfolgreich",
  surveyTitle: "Willkommen bei HitPaw Online",
  surveyStep1: "<1>Schritt 1</1>/3",
  surveyStep2: "<1>Schritt 2</1>/3",
  surveyStep3: "<1>Schritt 3</1>/3",
  surveyQuestion: "Was ist Ihr Ziel mit HitPaw?",
  surveyThemeQuestion: "Wählen Sie den gewünschten Modus",
  surveyAnswerOther: "Andere",
  surveyAnswer1: "Lebensstil-Video",
  surveyAnswer2: "Geschäftsvideo",
  surveyAnswer3: "Firmenvideo",
  surveyAnswer4: "Marketing-Video",
  surveyAnswer5: "Soziale Medien Video",
  surveyAnswer6: "Diashow Video",
  surveyAnswer7: "Video-Werkzeug",
  surveyAnswer8: "Reise-Video",
  surveyAnswer9: "Hochzeitsvideo",
  surveyAnswer10: "Geburtstagsvideo",
  surveyAnswer11: "Baby-Video",
  surveyAnswer12: "Tier Video",
  surveyAnswer13: "Lebensmittel Video",
  surveyAnswer14: "Mode Video",
  surveyAnswer15: "Urlaub Video",
  surveyAnswer16: "Sport Video",
  surveyAnswer17: "Fotografie Video",
  surveyAnswer18: "Musik Video",
  surveyAnswerLightMode: "Heller Modus",
  surveyAnswerDarkMode: "Dunkler Modus",
  surveyNextBtn: "Nächste",
  surveyBackBtn: "Zurück",
  surveyDoneBtn: "Fertig",
  surveyStartBtn: "Beginnen Sie",
  logoutWarnTips: "Sind Sie sicher, dass Sie sich abmelden wollen?",
};

export default loginAndSignUp;
